let currentStep = 1;
const totalSteps = 3;

function updateSteps() {
  // Toggle active state for steps
  $(".step").each(function () {
    $(this).toggleClass(
      "active",
      parseInt($(this).data("step")) === currentStep
    );
  });

  // Show/hide step content
  $(".step-content").each(function (index) {
    $(this).toggleClass("hidden", index + 1 !== currentStep);
  });

  // Previous button visibility
  $("#prevStep").toggleClass("hidden", currentStep === 1);

  // Next button visibility and text
  const $nextStep = $("#nextStep");
  if (currentStep < totalSteps) {
    const nextTitle = $(`.step[data-step="${currentStep + 1}"] h4`).text();
    $nextStep.text(`NEXT STEP: ${nextTitle}`).removeClass("hidden");
  } else {
    $nextStep.addClass("hidden"); // Hide on last step
  }

  // Validate current step inputs
  validateInputs();
}

function validateInputs() {
  const currentContent = $(".step-content").eq(currentStep - 1);
  let allValid = true;

  // Check if each fieldset has a selected radio
  currentContent.find("fieldset").each(function () {
    if (!$(this).find('input[type="radio"]:checked').length) {
      allValid = false;
    }
  });

  // Check if all dropdowns have a value
  currentContent.find("select").each(function () {
    if (!$(this).val()) {
      allValid = false;
    }
  });

  // Enable/disable next button (only if it's visible)
  const $nextStep = $("#nextStep");
  if (currentStep < totalSteps) {
    $nextStep.prop("disabled", !allValid);
  }
}

// Event listeners
$("#nextStep").on("click", function () {
  if (currentStep < totalSteps) {
    currentStep++;
    updateSteps();
    $(".buttons").css("justify-content", "space-between");
  }
});

$("#prevStep").on("click", function () {
  if (currentStep > 1) {
    currentStep--;
    updateSteps();
  }
});

// Live input change validation
$(document).on("change", 'input[type="radio"], select', function () {
  validateInputs();
});

// Initial setup on page load
$(document).ready(function () {
  updateSteps();
});

$(document).ready(function () {
  // Quantity +/-
  $(".mak__quantity-plus").on("click", function () {
    const $input = $(this).siblings(".mak__quantity-input");
    const currentVal = parseInt($input.val()) || 1;
    $input.val(currentVal + 1).trigger("input");
  });

  $(".mak__quantity-minus").on("click", function () {
    const $input = $(this).siblings(".mak__quantity-input");
    const currentVal = parseInt($input.val()) || 1;
    if (currentVal > 1) {
      $input.val(currentVal - 1).trigger("input");
    }
  });

  function buildHiddenInputs() {
    const container = $("#atc-hidden-inputs-container");
    container.empty();

    const properties = getSelectedProperties();

    // Get current quantity
    const quantity = parseInt($(".mak__quantity-input").val()) || 1;

    // Inject properties
    Object.entries(properties).forEach(([key, val]) => {
      if (val !== undefined && val !== null && val !== "") {
        container.append(
          `<input type="hidden" name="properties[${key}]" value="${val}">`
        );
      }
    });

    // Add extra variants (upsells)
    let extraVariants = [];

    $("input[type='radio']:checked").each(function () {
      const variantId = $(this).data("extra-variant-id");
      if (variantId) {
        extraVariants.push(variantId);
      }
    });

    $("select").each(function () {
      const selectedOption = $(this).find("option:selected");
      const variantId = selectedOption.data("extra-variant-id");
      if (variantId) {
        extraVariants.push(variantId);
      }
    });

    // Append extra items with same quantity as main
    extraVariants.forEach((variantId, index) => {
      const itemIndex = index + 1;
      container.append(`
      <input type="hidden" name="items[${itemIndex}][id]" value="${variantId}">
      <input type="hidden" name="items[${itemIndex}][quantity]" value="${quantity}">
    `);
    });
  }

  function getSelectedProperties() {
    return {
      Hand: $("input[name='properties[Hand]']:checked").val(),
      "Putting Style": $(
        "input[name='properties[Putting Style]']:checked"
      ).val(),
      "Head Weight": $("input[name='properties[Head Weight]']:checked").val(),
      Shaft: $("#shaft").val(),
      "Shaft Length": $("#shaft-length").val(),
      "Shaft Lean": $("#shaft-lean").val(),
      Insert: $("#insert").val(),
      "Lie Angle": $("#lie-angle").val(),
      "Putter Color": $("input[name='properties[Putter Color]']:checked").val(),
      "Alignment Mark Front": $("#alignment-mark-front").val(),
      "Alignment Mark Back": $("#alignment-mark-back").val(),
      "Grip Selection": $("#grip-selection").val(),
      "Headcover Selection": $(
        "input[name='properties[Headcover Selection]']:checked"
      ).val(),
      "Putter build time": $(
        "input[name='properties[Putter build time]']:checked"
      ).val(),
      "Player name": $("#player-name").val() || "",
    };
  }

  function validateForm() {
    const requiredFields = [
      "input[name='properties[Hand]']:checked",
      "input[name='properties[Putting Style]']:checked",
      "input[name='properties[Head Weight]']:checked",
      "#shaft",
      "#shaft-length",
      "#shaft-lean",
      "#insert",
      "#lie-angle",
      "input[name='properties[Putter Color]']:checked",
      "#alignment-mark-front",
      "#alignment-mark-back",
      "#grip-selection",
      "input[name='properties[Headcover Selection]']:checked",
      "input[name='properties[Putter build time]']:checked",
    ];

    let isValid = true;

    requiredFields.forEach((selector) => {
      const $el = $(selector);
      if ($el.length === 0 || !$el.val()) {
        isValid = false;
      }
    });

    $("#mak-atc").prop("disabled", !isValid);
  }

  $(document).on("change input", "input, select", function () {
    buildHiddenInputs();
    validateForm();
  });

  buildHiddenInputs();
  validateForm();

  $("#shaft").on("change", function () {
    if ($(this).val() !== "") {
      $(".mak_drop-slection").show();
    } else {
      $(".mak_drop-slection").hide();
    }
  });
});
$(document).ready(function () {
  const productHandle = $(".customization-group").data("product-handle");

  function updateSlidesByColor(selectedColor) {
    const colorSlug = selectedColor.toLowerCase().trim();
    const targetAltTag = `${productHandle} / ${colorSlug}`.toLowerCase();

    // Check both mobile and desktop thumbnail selectors
    const allDots = $(
      ".product-thumbnail-carousel-mobile__thumb[data-variant], .product-thumbnail-carousel__thumb[data-variant]"
    );

    allDots.each(function () {
      const variant = $(this).data("variant")?.toLowerCase().trim() || "";
      if (variant === targetAltTag) {
        $(this).trigger("click");
      }
    });
  }

  function handleInitialColor() {
    const initialColor = $(
      'input[name="properties[Putter Color]"]:checked'
    ).val();
    if (initialColor) {
      updateSlidesByColor(initialColor);
    }
  }

  handleInitialColor();

  $('input[name="properties[Putter Color]"]').on("change", function () {
    const selectedColor = $(this).val();
    updateSlidesByColor(selectedColor);
  });
});
